<template>
  <div class="basic_information">
    <div class="title">工商信息</div>
    <el-form style="width: 640px;" :model="info_form" :rules="rules" label-position="top" ref="infoForm" label-width="100px" class="demo-ruleForm">
      <el-form-item label="企业名称" prop="company_name">
        <el-input v-model="info_form.company_name" placeholder="请输入企业名称" :maxlength="30" show-word-limit> </el-input>
      </el-form-item>
      <el-form-item label="成立时间" prop="registration_date">
        <div class="picker_box">
          <el-date-picker value-format="yyyy-MM-dd" style="width: 100%;" suffix-icon="el-icon-date" v-model="info_form.registration_date" type="date" placeholder="年/月/日">
          </el-date-picker>
          <i class="el-icon-date data_icon"></i>
        </div>
      </el-form-item>
      <el-form-item label="企业类型" prop="company_type">
        <el-select style="width: 100%;" v-model="info_form.company_type" placeholder="请选择">
          <el-option v-for="item in companyTypeOption" :key="item.label" :label="item.label" :value="item.label">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="经营状态" prop="business_status">
        <el-select style="width: 100%;" v-model="info_form.business_status" placeholder="请选择">
          <el-option v-for="item in businessStatusOption" :key="item.label" :label="item.label" :value="item.label">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="注册资本" prop="registered_capital">
        <el-input-number style="width: 80%;" v-model="info_form.registered_capital" :controls="false"></el-input-number> <span style="margin: 0 10px;">万人民币</span>
      </el-form-item>
      <el-form-item label="注册地址" prop="registered_address">
        <el-cascader @change="handleCascaderChange" ref="cascaderRef" style="width: 100%;" v-model="info_form.registered_address" :options="citys"></el-cascader>
      </el-form-item>
      <el-form-item label="营业期限" prop="business_time">
        <div class="picker_input">
          <el-date-picker value-format="yyyy-MM-dd" class="picker_input" v-model="info_form.business_time" type="daterange" range-separator="-" start-placeholder="年/月/日" end-placeholder="年/月/日">
          </el-date-picker>
          <i class="el-icon-date data_icon1"></i>
          <i class="el-icon-date data_icon2"></i>
        </div>
      </el-form-item>
      <el-form-item label="所属地区" prop="region">
        <el-select style="width: 50%;" v-model="info_form.region" placeholder="请选择省">
          <el-option v-for="item in citys" :key="item.label" :label="item.label" :value="item.label">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="统一社会信用代码" prop="unified_social_credit_code">
        <el-input v-model="info_form.unified_social_credit_code" maxlength="18" show-word-limit placeholder="请输入统一社会信用代码"> </el-input>
      </el-form-item>
      <el-form-item label="校准日期" prop="approval_date">
        <div class="picker_box">
          <el-date-picker value-format="yyyy-MM-dd" style="width: 100%;" suffix-icon="el-icon-date" v-model="info_form.approval_date" type="date" placeholder="年/月/日">

          </el-date-picker>
          <i class="el-icon-date data_icon"></i>
        </div>

      </el-form-item>
      <el-form-item label="曾用名" prop="previous_name">
        <el-input v-model="info_form.previous_name" placeholder="请输入曾用名" :maxlength="30" show-word-limit> </el-input>
      </el-form-item>
      <el-form-item label="登记机关" prop="registration_authority">
        <el-input v-model="info_form.registration_authority" placeholder="请输入登记机关"> </el-input>
      </el-form-item>
      <el-form-item label="经营范围" prop="business_scope">
        <el-input type="textarea" maxlength="5000" show-word-limit autosize placeholder="请输入经营范围" v-model="info_form.business_scope">
        </el-input>
      </el-form-item>
      <el-form-item label="公司地址" prop="detail_address">
        <div style="display: flex;align-items: center;">
          <div style="flex-shrink: 0;">省市区</div>
          <el-select v-model="city" placeholder="请选择省" style="margin-left: 10px;" @change="selectCity">
            <el-option v-for="item in citys" :key="item.label" :label="item.label" :value="item.label">
            </el-option>
          </el-select>
          <el-select v-model="municipal" placeholder="请选择市" style="margin: 0 10px;" @change="selectMunicipal">
            <el-option v-for="item in municipalOption" :key="item.label" :label="item.label" :value="item.label">
            </el-option>
          </el-select>
          <el-select v-model="area" placeholder="请选择区">
            <el-option v-for="item in areaOption" :key="item.label" :label="item.label" :value="item.label">
            </el-option>
          </el-select>
        </div>
        <div class="detial_box">
          <div class="left">详细地址</div>
          <div class="right">
            <div class="add_box"><el-input style="width: 480px;" v-model="input_address"></el-input><span class="addbutton" @click="addAdress">添加地址</span></div>
            <div class="add_box" v-for="(item,index) in info_form.detail_address">
              <div class="show_box">{{ item.province+item.city+item.district+item.address}}</div><span class="deletebutton" @click="deleteAddress(index)">删除地址</span>
            </div>
          </div>
        </div>
      </el-form-item>
    </el-form>
    <el-button class="save_button" @click="submitForm('infoForm')">保存</el-button>

  </div>
</template>

<script>
import citys from "../../utils/city";
export default {
  name: "",
  data() {
    //校验统一社会信用代码
    var checkCode = (rule, value, callback) => {
      if (!value) {
        callback("请输入统一社会信用代码");
      } else {
        // let result = this.validateCreditCode(value);
        // if (!result) {
        // callback("统一社会信用代码格式不正确");
        // } else {
        callback();
        // }
      }
    };
    return {
      info_form: {
        company_name: "",
        company_type: "",
        registration_date: "",
        business_time: [],
        business_status: "",
        business_start_time: "",
        business_end_time: "",
        registered_capital: undefined,
        registration_authority: "",
        unified_social_credit_code: "",
        business_scope: "",
        detail_address: [],
        approval_date: "",
        previous_name: "",
        region: "",
        registered_address_info: {
          province: {
            code: "",
            name: "",
          },
          city: {
            code: "",
            name: "",
          },
          district: {
            code: "",
            name: "",
          },
        },
        registered_address:[]
      },
      rules: {
        registration_date: [
          { required: true, message: "请选择成立时间", trigger: "change" },
        ],
        company_name: [
          { required: true, message: "请输入企业名称", trigger: "blur" },
          {
            min: 2,
            max: 30,
            message: "长度在 2 到 30 个字符",
            trigger: "blur",
          },
        ],
        company_type: [
          { required: true, message: "请选择企业类型", trigger: "change" },
        ],
        business_status: [
          { required: true, message: "请选择经营状态", trigger: "change" },
        ],
        registered_capital: [
          { required: true, message: "请输入注册资本", trigger: "blur" },
        ],
        registered_address: [
          { required: true, message: "请选择注册地址", trigger: "change" },
        ],
        business_time: [
          { required: true, message: "请选择营业期限", trigger: "change" },
        ],
        region: [
          { required: true, message: "请选择省市区", trigger: "change" },
        ],
        unified_social_credit_code: [{ validator: checkCode, trigger: "blur" }],
        approval_date: [
          { required: true, message: "请选择核准日期", trigger: "change" },
        ],
        registration_authority: [
          { required: true, message: "请输入登记机关", trigger: "blur" },
        ],
        business_scope: [
          { required: true, message: "请输入经营范围", trigger: "blur" },
        ],
        detail_address: [
          { required: true, message: "请添加公司地址", trigger: "change" },
        ],
      },
      companyTypeOption: [
        {
          label: "有限责任公司",
        },
        {
          label: "股份有限公司",
        },
        {
          label: "国有独资企业",
        },
        {
          label: "合伙企业",
        },
        {
          label: "个人独资企业",
        },
      ],
      businessStatusOption: [
        {
          label: "存续",
        },
        {
          label: "在业",
        },
        {
          label: "吊销",
        },
        {
          label: "注销",
        },
        {
          label: "迁入",
        },
        {
          label: "迁出",
        },
        {
          label: "停业",
        },
        {
          label: "清算",
        },
      ],
      citys: citys,
      city: "",
      municipal: "",
      area: "",
      citysOption: [],
      municipalOption: [],
      areaOption: [],
      input_address: "",
    };
  },
  components: {},
  mounted() {
    this.getCompanyDetial();
  },

  methods: {
    isValidUSCI(code) {
      // 检查是否为18位
      if (code.length !== 18) {
        return false;
      }
      // 检查是否全是数字或大写字母
      const regex = /^[0-9A-Z]{18}$/;
      if (!regex.test(code)) {
        return false;
      }
      return true;
    },
    calculateCheckDigit(code) {
      const weights = [
        1, 3, 9, 27, 19, 26, 16, 17, 20, 29, 25, 13, 8, 24, 10, 30, 28,
      ];
      let sum = 0;
      for (let i = 0; i < 17; i++) {
        let charCode = code.charCodeAt(i);
        let digit =
          charCode >= "A".charCodeAt(0) && charCode <= "Z".charCodeAt(0)
            ? charCode - "A".charCodeAt(0) + 10
            : charCode - "0".charCodeAt(0);
        sum += digit * weights[i];
      }
      let checkDigit = 31 - (sum % 31); // 余数为31时不需加1，否则加1得到校验码
      checkDigit =
        checkDigit === 31
          ? "0"
          : checkDigit < 10
          ? checkDigit.toString()
          : String.fromCharCode(checkDigit + "A".charCodeAt(0) - 10); // 转换成字符或数字
      return checkDigit;
    },
    validateCreditCode(code) {
      // 基本格式校验
      if (!this.isValidUSCI(code)) {
        return false;
      }
      // 计算并验证第18位校验码
      // const calculatedCheckDigit = this.calculateCheckDigit(
      //   code.substring(0, 17)
      // ); // 只取前17位计算校验码
      // return calculatedCheckDigit === code[17]; // 比较第18位是否匹配计算结果
    },
    handleCascaderChange(value) {
      // 获取选中的标签

      let selectedLabels = this.getLabelsByValues(this.citys, value);
      console.log("selectedLabels", this.info_form);

      this.info_form.registered_address_info.province.code =
        selectedLabels[0].value;
      this.info_form.registered_address_info.province.name =
        selectedLabels[0].label;
      this.info_form.registered_address_info.city.code =
        selectedLabels[1].value;
      this.info_form.registered_address_info.city.name =
        selectedLabels[1].label;
      this.info_form.registered_address_info.district.code =
        selectedLabels[2].value;
      this.info_form.registered_address_info.district.name =
        selectedLabels[2].label;
    },
    getLabelsByValues(options, values) {
      const labels = [];
      let currentOptions = options;
      for (const value of values) {
        const option = currentOptions.find((option) => option.value === value);
        if (option) {
          labels.push({ label: option.label, value: option.value });
          currentOptions = option.children || [];
        }
      }
      return labels;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.info_form.business_start_time = this.info_form.business_time[0];
          this.info_form.business_end_time = this.info_form.business_time[1];

          this.$httpcompany.axiosPost(
            this.$api.companySaveRegistrationInfo,
            this.info_form,
            (res) => {
              if (res.code == 200) {
                this.$message.success("保存成功");
              } else {
                this.$message({
                  type: "error",
                  message: res.message,
                });
              }
            }
          );
          //
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    selectCity() {
      this.municipalOption = [];
      this.areaOption = [];
      let obj = this.citys.find((item) => item.label == this.city);
      if (obj) {
        this.municipalOption = obj.children;
      }
    },
    selectMunicipal() {
      this.areaOption = [];
      let obj = this.municipalOption.find(
        (item) => item.label == this.municipal
      );
      if (obj) {
        this.areaOption = obj.children;
      }
    },
    addAdress() {
      if (this.info_form.detail_address.length >= 3) {
        this.$message.warning("最多添加三个详细地址");
        return;
      }
      if (!this.city || !this.municipal || !this.area) {
        this.$message.warning("请先选择省市区");
        return;
      }
      if (this.input_address.trim() == "") {
        this.$message.warning("详细地址不能为空");
        return;
      }
      this.info_form.detail_address.push({
        province: this.city,
        city: this.municipal,
        district: this.area,
        address: this.input_address,
      });
      this.input_address = "";
      this.city = "";
      (this.municipal = ""), (this.area = "");
      this.municipalOption = [];
      this.areaOption = [];
    },
    deleteAddress(index) {
      this.info_form.detail_address.splice(index, 1);
    },
    getCompanyDetial() {
      this.$httpcompany.axiosGet(this.$api.companyDetail, (res) => {
        if (res.code == 200) {
          for (const key in this.info_form) {
            if (key in res.data && res.data[key]) {
              this.info_form[key] = res.data[key];
            }
          }
          if (
            this.info_form.business_start_time &&
            this.info_form.business_end_time
          ) {
            this.info_form.business_time = [
              this.info_form.business_start_time,
              this.info_form.business_end_time,
            ];
          }
          if (this.info_form.registered_address_info.province?.code) {
            this.info_form.registered_address = [
              this.info_form.registered_address_info.province.code,
              this.info_form.registered_address_info.city.code,
              this.info_form.registered_address_info.district.code,
            ];
          } else {
            this.info_form.registered_address_info = {
              province: {
                code: "",
                name: "",
              },
              city: {
                code: "",
                name: "",
              },
              district: {
                code: "",
                name: "",
              },
            };
          }
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },
  },
};
</script>
<style lang='scss' scoped>
.basic_information {
  padding-bottom: 20px;
  box-sizing: border-box;
  .title {
    font-weight: 500;
    font-size: 20px;
    color: #393837;
    margin-bottom: 34px;
  }
}
.show_industry {
  width: 400px;
  height: 40px;
  background: #ffffff;
  border-radius: 4px 4px 4px 4px;
  border: 1px solid #dcdfe6;
  padding: 0 15px;
  box-sizing: border-box;
  font-weight: 400;
  font-size: 14px;
  color: #c4c7d9;
  cursor: pointer;
}
.file-top_btn {
  display: flex;
  width: 120px;
  height: 120px;
  background: #f6f6f6;
  border-radius: 8px 8px 8px 8px;
  border: 1px solid #e6e8eb;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  font-size: 14px;
  color: #667085;
  cursor: pointer;
  .img_icon {
    width: 32px;
    height: 32px;
  }
  .logo_img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 8px;
  }
}
.save_button {
  width: 86px;
  height: 34px;
  background: #685ef5;
  border-radius: 4px 4px 4px 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
}
.detial_box {
  display: flex;
  margin-top: 20px;
  .left {
    flex-shrink: 0;
    margin-top: 10px;
  }
  .right {
    flex: 1;
    margin-left: 10px;
    .add_box {
      display: flex;
      justify-content: space-between;
      margin-top: 10px;
      .show_box {
        width: 480px;
        height: 40px;
        background: #ffffff;
        border-radius: 4px 4px 4px 4px;
        border: 1px solid #dcdcdc;
        font-weight: 400;
        font-size: 14px;
        color: #333333;
        line-height: 40px;
        padding: 0 10px;
        box-sizing: border-box;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
      .addbutton {
        cursor: pointer;
        font-weight: 400;
        font-size: 14px;
        color: #685ef5;
      }
      .deletebutton {
        cursor: pointer;
        font-weight: 400;
        font-size: 14px;
        color: #f55e5e;
      }
    }
  }
}
::v-deep .el-input__inner {
  padding: 0 15px;
}
::v-deep .el-input__prefix {
  display: none !important;
}
::v-deep .el-textarea__inner {
  height: 100px !important;
}
::v-deep .el-input-number .el-input__inner {
  text-align: left;
}
::v-deep .el-input__icon {
  display: none;
}
::v-deep .el-range-input {
  border-radius: 4px 4px 4px 4px;
  border: 1px solid #dcdcdc;
  text-align: left;
  padding: 0 15px;
}

.picker_input {
  width: 100%;
  position: relative;
  .data_icon1 {
    position: absolute;
    top: 50%;
    left: calc(50% - 60px);
    transform: translate(-50%, -50%);
    font-size: 14px;
    color: #c0c4cc;
  }
  .data_icon2 {
    position: absolute;
    top: 50%;
    right: 45px;
    transform: translate(-50%, -50%);
    font-size: 14px;
    color: #c0c4cc;
  }
}
::v-deep .el-date-editor {
  border: none !important;
  padding: 0px !important;
}
.picker_box {
  position: relative;
  ::v-deep .el-input__suffix {
    right: 35px !important;
  }
  .data_icon {
    position: absolute;
    top: 50%;
    right: 10px;
    transform: translate(-50%, -50%);
    font-size: 14px;
    color: #c0c4cc;
  }
}
</style>
